"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));
var chartConfig = _interopRequireWildcard(require("@/components/Charts/chart.config.js"));
var _constants = require("@/config/constants");
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _PowerBI = _interopRequireDefault(require("./components/PowerBI.vue"));
var _auth = require("@/utils/auth");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var now = new Date();
var _default = exports.default = {
  name: 'DetailServiceConnectionMonitor',
  bodyClass: 'service-detail-connection-monitor-page',
  components: {
    TableLastRequestsList: _components.TableLastRequestsList,
    TableServicesInactivesCallsList: _components.TableServicesInactivesCallsList,
    LineChart: _LineChart.default,
    PowerBi: _PowerBI.default
  },
  data: function data() {
    return {
      activeTab: 0,
      idService: null,
      service: {},
      dates: [now, now],
      details: {},
      list: [],
      listNotFetchs: [],
      chartDataCreatedHive: {},
      chartDataCreatedProvider: {},
      chartDataReceivedHive: {},
      chartDataSendClient: {},
      chartDataRequestTime: {},
      chartRequestsTotal: null,
      chartRequestsCompare: null,
      chartRequestsMonetizablesTotal: null,
      listRequestsTotalErros: null,
      listRequestsTotalsxlistRequestM: [],
      totalRequestsMonetizables: {},
      totalRequests: {},
      chartOptions: _constants.OPTIONS_CHART_DEFAULT,
      loadChartCreatedHive: true,
      loadChartCreatedProvider: true,
      loadChartReceivedHive: true,
      loadChartSendClient: true,
      loadChartRequestTime: true,
      loadTotalRequests: true,
      loadLastRequestsByStep: true,
      requestsTimeIntervals: []
    };
  },
  computed: {
    filterItems: function filterItems() {
      return {
        startDate: (0, _moment.default)(this.dates[0]).format('YYYY-MM-DD'),
        endDate: (0, _moment.default)(this.dates[1]).add(1, 'days').format('YYYY-MM-DD')
      };
    },
    user: function user() {
      return (0, _auth.getUser)().user;
    },
    isAdmin: function isAdmin() {
      return this.user.roleAdmin;
    },
    diffDate: function diffDate() {
      var dateInit = (0, _moment.default)(this.dates[0]);
      var dateEnd = (0, _moment.default)(this.dates[1]);
      var diff = dateInit.diff(dateEnd, 'days');
      return diff;
    },
    titleProtocolsCreatedHive: function titleProtocolsCreatedHive() {
      if (this.diffDate === 0) return 'Aberto na Hive por minuto';
      return 'Protocolos criado no Hive';
    },
    titleProtocolsCreatedProvider: function titleProtocolsCreatedProvider() {
      if (this.diffDate === 0) return 'Criado no Provedor por minuto';
      return 'Protocolos criados no Provedor';
    },
    titleProtocolsReceivedHive: function titleProtocolsReceivedHive() {
      if (this.diffDate === 0) return 'Webhooks para a Hive por minuto';
      return 'Webhooks recebidos na Hive';
    },
    titleProtocolsSendClient: function titleProtocolsSendClient() {
      if (this.diffDate === 0) return 'Respostas enviadas ao cliente por minuto';
      return 'Respostas enviadas ao cliente';
    },
    titleTimeRequest: function titleTimeRequest() {
      if (this.diffDate === 0) return 'Tempo de requisição';
      return 'Tempo de requisição';
    },
    successRate: function successRate() {
      var _this$totalRequests, _this$totalRequests2;
      var protocolsCreateds = ((_this$totalRequests = this.totalRequests) === null || _this$totalRequests === void 0 ? void 0 : _this$totalRequests.totalCreatedHive) || 0;
      var protocolsCreatedsProvider = ((_this$totalRequests2 = this.totalRequests) === null || _this$totalRequests2 === void 0 ? void 0 : _this$totalRequests2.totalCreatedProvider) || 0;
      var result = (protocolsCreatedsProvider / protocolsCreateds * 100).toFixed(2);
      if (result) {
        return Number(result);
      }
      return 0;
    },
    errorRate: function errorRate() {
      var _this$totalRequests3, _this$totalRequests4;
      var protocolsCreateds = ((_this$totalRequests3 = this.totalRequests) === null || _this$totalRequests3 === void 0 ? void 0 : _this$totalRequests3.totalCreatedHive) || 0;
      var protocolsCreatedsProvider = ((_this$totalRequests4 = this.totalRequests) === null || _this$totalRequests4 === void 0 ? void 0 : _this$totalRequests4.totalCreatedProvider) || 0;
      var totalErros = protocolsCreateds - protocolsCreatedsProvider;
      var result = (totalErros / protocolsCreateds * 100).toFixed(2);
      if (result) {
        return Number(result);
      }
      return 0;
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.idService = id;
    this.updateChart();
    this.getDetailService();
    this.getTotalRequests();
    this.getLastRequestByStep();
    this.getRequestsErrors();
    this.getRequestsTimeIntervals();
    this.setInitialTab();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailService', 'fetchTotalRequestByService', 'fetchChartRequestCreatedHive', 'fetchChartRequestCreatedProvider', 'fetchChartRequestReceivedHive', 'fetchChartRequestSendClient', 'fetchLatestRequestStepByService', 'fetchMonitorRequestsTimeIntervals', 'featchLastServiceActiveCallsTotalErros', 'fetchChartRequestTime'])), {}, {
    updateDataItems: function () {
      var _updateDataItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.getDetailService();
              this.getTotalRequests();
              this.updateChart();
              this.getLastRequestByStep();
              this.getRequestsErrors();
              this.getRequestsTimeIntervals();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function updateDataItems() {
        return _updateDataItems.apply(this, arguments);
      }
      return updateDataItems;
    }(),
    updateChart: function updateChart() {
      this.getChartDataCreatedHive();
      this.getChartDataCreatedProvider();
      this.getChartDataReceivedHive();
      this.getChartDataSendClient();
      this.getChartDataRequestTime();
    },
    updateChartCreatedHive: function updateChartCreatedHive() {
      this.getChartDataCreatedHive();
    },
    updateChartCreatedProvider: function updateChartCreatedProvider() {
      this.getChartDataCreatedProvider();
    },
    updateChartReceivedHive: function updateChartReceivedHive() {
      this.getChartDataReceivedHive();
    },
    updateChartSendClient: function updateChartSendClient() {
      this.getChartDataSendClient();
    },
    updateChartRequestTime: function updateChartRequestTime() {
      this.getChartDataRequestTime();
    },
    getDetailService: function () {
      var _getDetailService = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchDetailService(this.idService);
            case 1:
              data = _context2.v;
              if (data) this.service = data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetailService() {
        return _getDetailService.apply(this, arguments);
      }
      return getDetailService;
    }(),
    getTotalRequests: function () {
      var _getTotalRequests = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.loadTotalRequests = true;
              _context3.n = 1;
              return this.fetchTotalRequestByService({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context3.v;
              if (data) this.totalRequests = data;
              this.loadTotalRequests = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getTotalRequests() {
        return _getTotalRequests.apply(this, arguments);
      }
      return getTotalRequests;
    }(),
    getChartDataCreatedHive: function () {
      var _getChartDataCreatedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.loadChartCreatedHive = true;
              _context4.n = 1;
              return this.fetchChartRequestCreatedHive({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context4.v;
              if (data) this.chartDataCreatedHive = data;
              this.loadChartCreatedHive = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getChartDataCreatedHive() {
        return _getChartDataCreatedHive.apply(this, arguments);
      }
      return getChartDataCreatedHive;
    }(),
    getChartDataCreatedProvider: function () {
      var _getChartDataCreatedProvider = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.loadChartCreatedProvider = true;
              _context5.n = 1;
              return this.fetchChartRequestCreatedProvider({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context5.v;
              if (data) {
                this.chartDataCreatedProvider = data;
              }
              this.loadChartCreatedProvider = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getChartDataCreatedProvider() {
        return _getChartDataCreatedProvider.apply(this, arguments);
      }
      return getChartDataCreatedProvider;
    }(),
    getChartDataReceivedHive: function () {
      var _getChartDataReceivedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.loadChartReceivedHive = true;
              _context6.n = 1;
              return this.fetchChartRequestReceivedHive({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context6.v;
              if (data) {
                this.chartDataReceivedHive = data;
              }
              this.loadChartReceivedHive = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getChartDataReceivedHive() {
        return _getChartDataReceivedHive.apply(this, arguments);
      }
      return getChartDataReceivedHive;
    }(),
    getChartDataSendClient: function () {
      var _getChartDataSendClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.loadChartSendClient = true;
              _context7.n = 1;
              return this.fetchChartRequestSendClient({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context7.v;
              if (data) {
                this.chartDataSendClient = data;
              }
              this.loadChartSendClient = false;
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function getChartDataSendClient() {
        return _getChartDataSendClient.apply(this, arguments);
      }
      return getChartDataSendClient;
    }(),
    getChartDataRequestTime: function () {
      var _getChartDataRequestTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this.loadChartRequestTime = true;
              _context8.n = 1;
              return this.fetchChartRequestTime({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context8.v;
              if (data) {
                this.chartDataRequestTime = data;
              }
              this.loadChartRequestTime = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function getChartDataRequestTime() {
        return _getChartDataRequestTime.apply(this, arguments);
      }
      return getChartDataRequestTime;
    }(),
    getLastRequestByStep: function () {
      var _getLastRequestByStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var data;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.loadLastRequestsByStep = true;
              _context9.n = 1;
              return this.fetchLatestRequestStepByService({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context9.v;
              if (data) this.list = data;
              this.loadLastRequestsByStep = false;
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function getLastRequestByStep() {
        return _getLastRequestByStep.apply(this, arguments);
      }
      return getLastRequestByStep;
    }(),
    getRequestsErrors: function () {
      var _getRequestsErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.featchLastServiceActiveCallsTotalErros({
                id: this.idService,
                params: this.filterItems
              });
            case 1:
              data = _context0.v;
              if (data) {
                this.listNotFetchs = data;
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function getRequestsErrors() {
        return _getRequestsErrors.apply(this, arguments);
      }
      return getRequestsErrors;
    }(),
    generateCompare: function () {
      var _generateCompare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.chartRequestsCompare = {
                labels: this.chartDataCreatedHive.labels,
                datasets: [_objectSpread({}, this.chartDataCreatedHive.datasets[0]), _objectSpread(_objectSpread({}, this.listRequestsTotalErros.datasets[0]), {}, {
                  label: 'Erros',
                  backgroundColor: chartConfig.CHART_COLORS.red,
                  borderColor: chartConfig.CHART_COLORS.red
                })]
              };
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function generateCompare() {
        return _generateCompare.apply(this, arguments);
      }
      return generateCompare;
    }(),
    getRequestsTimeIntervals: function () {
      var _getRequestsTimeIntervals = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var data, getDescriptionTextFromTimeInterval, total, itens;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return this.fetchMonitorRequestsTimeIntervals({
                id: this.idService,
                startDate: this.filterItems.startDate,
                endDate: this.filterItems.endDate
              });
            case 1:
              data = _context10.v;
              if (data) {
                getDescriptionTextFromTimeInterval = function getDescriptionTextFromTimeInterval(timeInterval, totalRequestsTime, thisRequestTime) {
                  var percentage = Math.round((thisRequestTime * 100 / totalRequestsTime + Number.EPSILON) * 100) / 100;
                  switch (timeInterval) {
                    case 'from 0 to 5000':
                      return {
                        description: 'Menos de 5 segundos',
                        numberToSort: 0,
                        percentage: percentage
                      };
                    case 'from 5001 to 10000':
                      return {
                        description: 'Entre 5 e 10 segundos',
                        numberToSort: 5,
                        percentage: percentage
                      };
                    case 'from 10001 to 15000':
                      return {
                        description: 'Entre 10 e 15 segundos',
                        numberToSort: 10,
                        percentage: percentage
                      };
                    case 'from 15001 to 30000':
                      return {
                        description: 'Entre 15 e 30 segundos',
                        numberToSort: 15,
                        percentage: percentage
                      };
                    case 'from 30001 to 45000':
                      return {
                        description: 'Entre 30 e 45 segundos',
                        numberToSort: 30,
                        percentage: percentage
                      };
                    case 'from 45001 to 60000':
                      return {
                        description: 'Entre 45 e 60 segundos',
                        numberToSort: 45,
                        percentage: percentage
                      };
                    case 'from 60001 to 120000':
                      return {
                        description: 'Entre 1 e 2 minutos',
                        numberToSort: 60,
                        percentage: percentage
                      };
                    case 'up to 120001':
                      return {
                        description: 'Acima de 2 minutos',
                        numberToSort: 120,
                        percentage: percentage
                      };
                    case 'from 0 to 30000':
                      return {
                        description: 'Menos de 30 segundos',
                        numberToSort: 0,
                        percentage: percentage
                      };
                    case 'from 30001 to 60000':
                      return {
                        description: 'Entre 30 segundos e 1 minuto',
                        numberToSort: 30,
                        percentage: percentage
                      };
                    case 'from 120001 to 300000':
                      return {
                        description: 'Entre 2 e 5 minutos',
                        numberToSort: 120,
                        percentage: percentage
                      };
                    case 'from 300001 to 600000':
                      return {
                        description: 'Entre 5 e 10 minutos',
                        numberToSort: 300,
                        percentage: percentage
                      };
                    case 'from 600001 to 900000':
                      return {
                        description: 'Entre 10 e 15 minutos',
                        numberToSort: 600,
                        percentage: percentage
                      };
                    case 'from 900001 to 1800000':
                      return {
                        description: 'Entre 15 e 30 minutos',
                        numberToSort: 900,
                        percentage: percentage
                      };
                    case 'up to 1800001':
                      return {
                        description: 'Acima de 30 minutos',
                        numberToSort: 1800,
                        percentage: percentage
                      };
                  }
                };
                total = data.reduce(function (total, item) {
                  return total + item.count;
                }, 0);
                itens = data.map(function (info) {
                  var intervalInfos = getDescriptionTextFromTimeInterval(info.timeInterval, total, info.count);
                  return {
                    quantity: info.count,
                    percentage: intervalInfos.percentage,
                    responseTime: intervalInfos.description,
                    numberToSort: parseInt(intervalInfos.numberToSort)
                  };
                });
                this.requestsTimeIntervals = itens.sort(function (a, b) {
                  return a.numberToSort - b.numberToSort;
                });
              }
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function getRequestsTimeIntervals() {
        return _getRequestsTimeIntervals.apply(this, arguments);
      }
      return getRequestsTimeIntervals;
    }(),
    goBack: function goBack() {
      this.$router.back();
    },
    setInitialTab: function setInitialTab() {
      var userPermition = (0, _auth.getUser)();
      if (userPermition.user.roleId === 14) {
        this.activeTab = 1;
      }
      return userPermition;
    }
  })
};